<template>
  <div class="sub-menu py1 xs-hide" :class="{ 'hover-item': hoverItem }">
    <!-- Sub Menu: Investigations -->
    <div
      v-if="showSubMenu('Investigations')"
      class="xs-hide center menu-bar z2 col-12 flex items-center justify-around"
    >
      <ul class="caps list-reset mt0 pt0 center col-12">
        <li class="px1 pointer"><router-link to="/">All</router-link></li>
        <li class="px1 hover-toggle pointer">
          <span
            :class="{ active: this.$route.name === 'Investigation Category' }"
            >By Category<span
              v-if="this.$route.name === 'Investigation Category'"
            >
              → {{ unSlug(this.$route.params.slug) }}</span
            ></span
          >
          <ul
            class="hover-show fs-s pt1 dropdown list-reset bg-fill z2 border-bottom"
          >
            <li
              class="px1"
              v-for="category in investigationCategories"
              :key="category.term_id"
            >
              <router-link
                :to="{
                  name: 'Investigation Category',
                  params: {
                    slug: category.slug,
                  },
                  meta: {
                    title: category.name,
                  },
                }"
                >{{ category.name }}</router-link
              >
            </li>
          </ul>
        </li>
        <li class="px1 hover-toggle pointer">
          <span
            :class="{
              active: this.$route.name === 'Investigation Methodology',
            }"
            >By Methodology<span
              v-if="this.$route.name === 'Investigation Methodology'"
            >
              → {{ unSlug(this.$route.params.slug) }}</span
            ></span
          >
          <ul
            class="hover-show fs-s pt1 dropdown list-reset bg-fill z2 border-bottom"
          >
            <li
              class="pl2"
              v-for="item in investigationMethodologies"
              :key="item.slug"
            >
              <router-link
                :to="{
                  name: 'Investigation Methodology',
                  params: {
                    slug: item.slug,
                  },
                }"
                >{{ item.name }}</router-link
              >
            </li>
          </ul>
        </li>
        <li class="px1 hover-toggle pointer">
          <span
            :class="{ active: this.$route.name === 'Investigation Location' }"
            >By Location<span
              v-if="this.$route.name === 'Investigation Location'"
            >
              → {{ unSlug(this.$route.params.slug) }}</span
            ></span
          >
          <ul
            class="hover-show fs-s pt1 dropdown list-reset bg-fill z2 border-bottom"
          >
            <li
              class="pl2"
              v-for="location in investigationLocations"
              :key="location.code"
            >
              <router-link
                :to="{
                  name: 'Investigation Location',
                  params: {
                    slug: location.slug,
                  },
                }"
                >{{ location.name }}</router-link
              >
            </li>
          </ul>
        </li>
        <li class="px1 pr2">
          <a @click.prevent="toggleMap()" href="/map">Map</a>
        </li>
        <!-- <span class="studies&#45;divider">|</span> -->
        <!-- <li class="px1"> -->
        <!--   <router&#45;link id="studies&#45;link" :to="{ name: 'Studies'}"> -->
        <!--     Studies -->
        <!--   </router&#45;link> -->
        <!-- </li> -->
      </ul>
    </div>

    <!-- Sub Menu: Programme -->
    <div
      v-else-if="showSubMenu('Programme')"
      class="xs-hide center menu-bar z2 col-12 flex items-center justify-around"
    >
      <ul class="caps list-reset mt0 pt0">
        <li class="mx1">
          <router-link :to="{ name: 'Exhibitions' }">Exhibitions</router-link>
        </li>
        <li class="mx1">
          <router-link :to="{ name: 'Events' }">Events</router-link>
        </li>
        <li class="mx1">
          <router-link :to="{ name: 'News' }">News</router-link>
        </li>
        <li class="mx1">
          <router-link :to="{ name: 'Publications' }">Publications</router-link>
        </li>
        <!-- <li class="mx1">
          <router-link :to="{ name: 'Programme', params: { page: 'academy' }}">Academy</router-link>
        </li> -->
      </ul>
    </div>

    <!-- Sub Menu: About -->
    <div
      v-else-if="showSubMenu('About')"
      class="xs-hide center menu-bar z2 col-12 flex items-center justify-around"
    >
      <ul class="caps list-reset mt0 pt0">
        <li class="mx1">
          <router-link :to="{ name: 'About', params: { page: 'agency' } }"
            >Agency</router-link
          >
        </li>
        <li class="mx1">
          <router-link :to="{ name: 'Team' }"
            >Team<span v-if="this.$route.name === 'Team Member'">
              → {{ unSlug(this.$route.params.slug) }}</span
            ></router-link
          >
        </li>
        <li class="mx1">
          <router-link
            :to="{ name: 'About', params: { page: 'advisory-board' } }"
            >Advisory Board</router-link
          >
        </li>
        <li class="mx1">
          <router-link :to="{ name: 'About', params: { page: 'funding' } }"
            >Funding</router-link
          >
        </li>
        <li class="mx1">
          <router-link :to="{ name: 'About', params: { page: 'recognition' } }"
            >Recognition</router-link
          >
        </li>
        <li class="mx1">
          <router-link :to="{ name: 'About', params: { page: 'jobs' } }"
            >Jobs</router-link
          >
        </li>
        <li class="mx1">
          <router-link :to="{ name: 'About', params: { page: 'press' } }"
            >Press</router-link
          >
        </li>
        <li class="mx1">
          <a href="https://contact.forensic-architecture.org">Contact</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "SubMenu",

  data() {
    return {};
  },

  props: ["content", "show", "nohide", "hoverItem"],

  computed: {
    ...mapState([
      "investigationCategories",
      "investigationLocations",
      "investigationMethodologies",
    ]),
  },

  methods: {
    ...mapActions(["toggleMap"]),
    showSubMenu(section) {
      if (this.content) {
        return this.content === section;
      } else {
        return this.$route.meta.subMenu === section;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.menu-bar {
  & > ul {
    &:hover {
      > li:hover {
        > a,
        > span {
          border-color: red;
        }
      }
      > li:not(:hover) {
        a,
        span {
          border-color: transparent !important;
        }
      }
    }
  }
}
.sub-menu {
  .active {
    font-style: italic;
    text-transform: capitalize;
    border-bottom: 1px solid var(--red);
  }

  ul {
    li {
      display: inline-block;

      a,
      & > span {
        display: inline-block;
        border-bottom: 1px solid transparent;
        padding-bottom: var(--link-border-padding);
      }

      &:hover > span,
      a:hover,
      & > span:hover {
        border-bottom: 1px solid var(--red);
      }

      a.router-link-exact-active {
        font-style: italic;
        text-transform: none;
        border-bottom: 1px solid var(--red);
      }
    }

    &.fs-s {
      a {
        padding-bottom: 0;
      }
    }
  }

  .dropdown {
    position: absolute;
    left: 0;
    width: 90%;
    padding-left: 5%;
    padding-right: 5%;
    line-height: 1.8;
    padding-bottom: 1em;
  }
}
#studies-link {
  /*font-style: normal;*/
  /*text-transform: uppercase;*/
  /*border-left: 1px solid #afafaf;*/
  /*padding-left: 0.6em;*/
}
.studies-divider {
  color: #cfcfcf;
}
.sub-menu.hover-item {
  padding-top: 10px;
  line-height: 1.05;
}
</style>
